import { render, staticRenderFns } from "./shejidangan.vue?vue&type=template&id=2759fbe9&scoped=true&"
import script from "./shejidangan.vue?vue&type=script&lang=js&"
export * from "./shejidangan.vue?vue&type=script&lang=js&"
import style0 from "./shejidangan.vue?vue&type=style&index=0&id=2759fbe9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2759fbe9",
  null
  
)

export default component.exports